import { render, staticRenderFns } from "./ScrollupBtn.vue?vue&type=template&id=203d37f8&"
import script from "./ScrollupBtn.vue?vue&type=script&lang=js&"
export * from "./ScrollupBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports